<template>
  <div class="row">
    <div class="col-md-12 card">
      <div class="card-header">
        <h4 class="title">Fleet drivers</h4>
      </div>
      <div class="card-body row">
        <v-server-table url="/v1/drivers" :columns="columns" :options="options">
          <template slot="id" slot-scope="props">
            <code>{{ props.row.id }}</code>
          </template>

          <template slot="createdAt" slot-scope="props">
            <div>{{ props.row.createdAt | moment('YYYY-MM-DD HH:mm A') }}</div>
          </template>

          <template slot="updatedAt" slot-scope="props">
            <div>{{ props.row.updatedAt | moment('YYYY-MM-DD HH:mm A') }}</div>
          </template>

          <template slot="isActive" slot-scope="props">
            <span v-if="props.row.isActive">Active</span>
            <span v-else-if="!props.row.isActive">Inactive</span>
          </template>

          <template slot="links" slot-scope="props">
            <router-link :to="`/account/drivers/${props.row.id}`" class="btn btn-default btn-sm">
              View &nbsp;
              <i class="fa fa-chevron-right"></i>
            </router-link>
          </template>
        </v-server-table>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";

const columns = [
  "id",
  "name",
  "phoneNumber",
  "emailAddress",
  "address",
  "postcode",
  "isActive",
  "links"
];

export default {
  name: "DriversList",
  data() {
    return {
      columns,
      options: {
        columnsDropdown: false,
        headings: {
          id: "Driver ID",
          name: "Name",
          phoneNumber: "Phone number",
          emailAddress: "Email address",
          address: "Address",
          postcode: "Postcode",
          isActive: "Active"
        },
        sortable: _.initial(columns),
        filterable: _.initial(columns),
        listColumns: {
          isActive: [
            {
              id: "true",
              text: "Active"
            },
            {
              id: "false",
              text: "Inctive"
            }
          ]
        }
      }
    };
  }
};
</script>